import { useMutation } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';

import { updatePatientNutritionAccount } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

export const useUpdatePatientNutritionAccount = () => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutate, isLoading } = useMutation({
    mutationFn: updatePatientNutritionAccount,
    onSuccess(data, variables) {
      if (data) {
        updateCache(variables.patientGuid, {
          weekMealStatus: data.weekMealStatus,
        });
      }
      showResult();
    },
  });

  return { updateNutritionAccount: mutate, nutritionAccountLoading: isLoading };
};
